import React, {useEffect, useState} from "react";
import {Ajax} from "../../Service/ajax";
import TeamNavbar from "./TeamNavBar";

export default function TeamForm({title, navigate}) {
    const allMembers = [];


    const [team, setTeam] = useState(null);
    const application=JSON.parse(sessionStorage.getItem("application"));
    const [loading, setLoading] = useState(false);
    const [teamCreating, setTeamCreating] = useState(false);
    const [status, setStatus] = useState(["All", "Invited", "Active", "Removed"]);
    const [selectedRole, setSelectedRole] = useState('');
    const [statusFilter, setStatusFilter] = useState('All');
    const filteredMembers = allMembers.filter(member => {
        const statusMatch = statusFilter === 'All' || member.status === statusFilter;
        const roleMatch = selectedRole === '' || member.role.name === selectedRole;
        return statusMatch && roleMatch;
    });

    const [searchTerm, setSearchTerm] = useState("");
    const [sortBy, setSortBy] = useState("invitedAt");
    const [sortOrder, setSortOrder] = useState("asc");
    const [showModal, setShowModal] = useState(false);
    const [roles, setRoles] = useState([]);

    const [userNumber, setUserNumber] = useState("");
    const [userRole, setUserRole] = useState("");

    const sortedMembers = [...filteredMembers].sort((a, b) => {
        const dateA = new Date(a.invitedAt);
        const dateB = new Date(b.invitedAt);

        return sortOrder === "asc"
            ? dateA - dateB
            : dateB - dateA;
    });

    const finalMembers = sortedMembers.filter(member =>
        member.userNumber.toLowerCase().includes(searchTerm.toLowerCase())
    );



    const handleRefresh = () => {
        // logique pour recharger les données
    };

    const toggleSortOrder = () => {
        setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
    };


    useEffect(() => {
        const fetchData = async ()=>{
            setLoading(true);
            try {
                const {data} = await Ajax.getRequest(`/api/v1/sub/teams/app/${application.id}`);
                setTeam(data);
                const fetchRoles = await Ajax.getRequest(`/api/v1/sub/roles/all`);
                setRoles(fetchRoles.data);
                //const fetchMembers = await Ajax.getRequest(`/api/v1/sub/members/team/${data.id}`);
            }catch (error){
                navigate("/error-page", { state: { errorCode: error.response.status } });
            }finally {
                setLoading(false);
            }
        }
        fetchData();
    },[])

    const createTeamFunction = async () => {
        try {
            setTeamCreating(true);
            const {data} = await Ajax.postRequest(`/api/v1/sub/teams`, {
                appId: application.id,
                members: [],
            });
            setTeam(data);
        }catch (e) {
            console.log(e);
        }finally {
            setTeamCreating(false)
        }
    }

    const inviteMemberFunction = async () => {
        try {
            const {data} = await Ajax.postRequest(`/api/v1/sub/members/invite`, {
                number: userNumber,
                role: userRole,
            });
            // if(data != null){
            //     const response = await Ajax.postRequest(`/api/v1/sub/teams/members/${application.id}`, data);
            //     setTeam(response.data);
            //     console.log("team: ",response.data);
            // }
        }catch (e) {
            console.log(e);
        }finally {
            setUserRole("")
            setUserNumber("");
            setShowModal(false)
        }
    }

    return (
        <div className="modal-content">
            <div className="modal-header">
                <TeamNavbar title={title}/>

            </div>
            <div className="modal-body">
                {loading ?
                    <div className="col-md-12 d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                        <div className="d-flex flex-column justify-content-center align-items-center w-100">
                            <i className="bx bx-group mb-3" style={{ fontSize: "3rem", color: "#eccd7e" }}></i>
                            <h2 className="text-center mb-3">
                                Bienvenue dans l'espace de gestion des équipes
                            </h2>
                            <p className="text-center mb-4">
                                Chargement des données, veuillez patienter...
                            </p>
                            <div className="spinner-border spinner-border-lg text-netikash" role="status">
                                <span className="visually-hidden">Chargement...</span>
                            </div>
                        </div>
                    </div>
                    :(
                    <>
                        {team ? <div className="col-md-12 d-flex flex-column align-items-center container-xxl" style={{ minHeight: "60vh" }}>
                                {/* En-tête */}
                                <div className="d-flex justify-content-between w-100 mb-3" style={{ height: "40px" }}>
                                    <h2>Membres</h2>
                                    {/*{*/}
                                    {/*    !showModal &&  allMembers.length <= 2 && <button className="btn btn-netikash py-1" onClick={()=>setShowModal(true)}>{"Inviter un membre"}</button>*/}
                                    {/*}*/}
                                </div>

                                {showModal &&
                                    <div className="w-100 border-top mb-2 pt-2">
                                        {/* Texte explicatif */}
                                        <div className="mb-2">
                                            <small className="text-muted">Inviter un membre dans l’équipe en entrant son numéro (whatsapp) et en sélectionnant son rôle</small>
                                        </div>

                                        {/* Champs de formulaire et boutons */}
                                        <div className="d-flex" style={{ alignItems: "flex-end", height: "40px" }}>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm me-2"
                                                placeholder="Numéro"
                                                onChange={(e) => setUserNumber(e.target.value)}
                                                style={{ maxWidth: "400px" }}
                                            />

                                            <select className="form-select form-select-sm me-2" style={{ maxWidth: "160px" }}
                                                    onChange={(e) => setUserRole(e.target.value)}>
                                                <option value="">Choisir un rôle</option>
                                                {roles.map((roleName, index) => (
                                                    <option key={index} value={roleName.title}>{roleName.title}</option>
                                                ))}
                                            </select>

                                            <button className="btn btn-netikash btn-sm me-2" disabled={!userNumber || !userRole} onClick={inviteMemberFunction}>
                                                Inviter
                                            </button>

                                            <button className="btn btn-outline-netikash btn-sm"
                                                    onClick={() =>setShowModal(false)}
                                            >
                                                Annuler
                                            </button>
                                        </div>
                                    </div>

                                }

                                {/* Liste des rôles avec bordure alignée */}
                                <div className="d-flex w-100 border-bottom border-top" style={{ height: "40px", alignItems: "flex-end" }}>
                                    {['All', 'Invited', 'Active', 'Removed'].map((status, index) => {
                                        const count = status === 'All'
                                            ? allMembers.length
                                            : allMembers.filter(member => member.status === status).length;

                                        return (
                                            <button
                                                key={index}
                                                onClick={() => setStatusFilter(status)}
                                                className={`bg-transparent border-0 px-2 pb-1 d-flex align-items-center gap-1 ${
                                                    statusFilter === status
                                                        ? 'border-bottom border-2 border-primary text-netikash fw-bold'
                                                        : 'text-secondary'
                                                }`}
                                                style={{ height: "100%", borderRadius: 0 }}
                                            >
                                                {status}
                                                <span className={`badge rounded-pill ${statusFilter === status ? 'bg-netikash text-white' : 'bg-light text-dark'}`}>
                                                    {count}
                                                  </span>
                                            </button>
                                        );
                                    })}

                                </div>
                                <div className="d-flex w-100 bg-light px-2, mb-2" style={{ height: "40px", alignItems: "center" }}>
                                    {/* Bouton de rafraîchissement */}
                                    <button onClick={handleRefresh} className="btn btn-sm btn-outline-netikash me-2">
                                        <i className="bx bx-refresh"></i>
                                    </button>

                                    {/* Champ de recherche */}
                                    <input
                                        type="text"
                                        placeholder="Rechercher par numéro"
                                        className="form-control form-control-sm me-2"
                                        style={{ maxWidth: "80%" }}
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />

                                    {/* Dropdown de tri */}
                                    <select
                                        className="form-select form-select-sm me-2"
                                        style={{ maxWidth: "160px" }}
                                        value={selectedRole}
                                        onChange={(e) => setSelectedRole(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        {[...new Set(allMembers.map(member => member.role.name))].map((roleName, index) => (
                                            <option key={index} value={roleName}>{roleName}</option>
                                        ))}
                                    </select>

                                    {/* Bouton pour changer l’ordre de tri */}
                                    <button onClick={toggleSortOrder} className="btn btn-sm btn-outline-netikash">
                                        <i className={`bx ${sortOrder === 'asc' ? 'bx-sort-up' : 'bx-sort-down'}`}></i>
                                    </button>
                                </div>

                                <div className="d-flex w-100" style={{ alignItems: "center" }}>
                                    <table className="w-100 border border-gray-200 text-left text-sm">
                                        <thead className="bg-gray-100">
                                        <tr>
                                            <th className="p-2 border">ID</th>
                                            <th className="p-2 border">User</th>
                                            <th className="p-2 border">Status</th>
                                            <th className="p-2 border">Role</th>
                                            <th className="p-2 border">Team</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {finalMembers.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="text-center py-4 text-muted">
                                                    Aucun membre trouvé
                                                </td>
                                            </tr>
                                        ) : (
                                            finalMembers.map(member => (
                                                <tr key={member.id} className="hover:bg-gray-50">
                                                    <td className="p-2 border">{member.id}</td>
                                                    <td className="p-2 border">{member.userId} ({member.userNumber})</td>
                                                    <td className="p-2 border">{member.status}</td>
                                                    <td className="p-2 border">{member.role.name}</td>
                                                    <td className="p-2 border">{member.team.name}</td>
                                                </tr>
                                            ))
                                        )}
                                        </tbody>
                                    </table>
                                </div>


                            </div>

                            :
                            <div className="col-md-12 d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                                <div className="d-flex flex-column justify-content-center align-items-center w-100">
                                    <i className="bx bx-group mb-3" style={{ fontSize: "3rem", color: "#eccd7e" }}></i>
                                    <h2 className="text-center mb-3">
                                        Bienvenue dans l'espace de gestion des équipes
                                    </h2>
                                    <p className="text-center mb-4">
                                        Vous n'avez pas encore d'équipe ? Créez votre équipe pour gérer efficacement votre organisation.
                                    </p>
                                    <button className="btn btn-netikash" onClick={createTeamFunction}>{teamCreating ? "traitement en cours...." : "Créer une équipe"}</button>
                                </div>
                            </div>
                        }
                    </>
                )}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-outline-netikash" data-bs-dismiss="modal" onClick={()=>console.log("close")}>
                    Fermer
                </button>
            </div>
        </div>
    );
}